<template>
  <el-dialog
    custom-class="renyuanDialog"
    width="800px"
    :visible.sync="showGroup"
    :before-close="handleClose"
    :show-close="false"
    :append-to-body="appendToBody"
  >
    <div slot="title" class="dialog-title">
      <span>应用设置</span>
    </div>
    <div :class="['person', { isAll: isAll === '1' }]">
      <el-radio v-model="isAll" label="1">全部成员</el-radio>
      <el-radio v-model="isAll" label="2">部分成员</el-radio>
    </div>
    <div class="dialog-body" v-show="isAll === '2'">
      <select-tab
        @initSource="getDepartUser"
        @checkNode="selectPerson"
        @searchNode="searchOrgPerson"
        @selectAllNode="selectAllPerson"
        @searchLines="getLines"
        @selectNextLevel="selectNextLevel"
        @removeNode="removePerson"
        :isWarning="warning"
        :isLine="isLine"
        :isShow="isCheckSet"
        :allChecked="allCheck"
        :title="title"
        :loading="loading"
        :userGroup="users"
        :sourceOrgs="sourceOrgs"
        :selectedList="selectedList"
      ></select-tab>
    </div>
    <div class="warn-tip" v-show="warning && isAll === '2'">
      请选择范围
    </div>
    <div class="dialog-btn-group">
      <el-button @click="handleClose" size="mini">取 消</el-button>
      <el-button
        style="margin-right: 10px;"
        type="primary"
        @click="saveForm"
        size="mini"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import SelectTab from './selectTab';
import { getDepartmentUser, queryLines } from '@/api/index';
import _ from 'lodash';
export default {
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    allShow: {
      type: Boolean,
      default: false
    },
    allPerson: {
      type: Boolean,
      default: false
    },
    showGroup: {
      type: Boolean
    },
    initData: {
      type: Object,
      default: () => {}
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SelectTab
  },
  created() {
    this.isAll = this.allPerson ? '1' : '2';
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      isLine: false,
      isCheckSet: true,
      isAll: '2',
      loading: false,
      allCheck: false,
      selectedList: [],
      title: '',
      sourceOrgs: [],
      users: [],
      warning: false
    };
  },
  watch: {
    selectedList(val) {
      if (val.length === 0) {
        this.warning = true;
      } else {
        this.warning = false;
      }
    }
  },
  methods: {
    async init() {
      if (this.edit) {
        const { departments = [], users = [], lines = [] } = this.initData;
        const newUsers = users.map(item => ({
          ..._.omit(item, ['departmentId'])
        }));

        this.selectedList = [...departments, ...newUsers];
        if (lines.length > 0) {
          this.isLine = true;
          this.selectedList = [
            ...this.selectedList,
            ...this.switchLineOrg(lines)
          ];
        }
        this.isCheckSet = true;
      }
      this.getDepartUser();
    },

    // 获取部门和用户
    async getDepartUser(departId = '') {
      this.loading = true;
      this.isLine = false;
      try {
        const params = departId ? { departmentId: departId } : {};
        const { body, code, message } = await getDepartmentUser(params);
        if (code === '0000') {
          let { departments, users } = body;
          const newUsers = users.map(item => ({
            ..._.omit(item, ['departmentId'])
          }));

          this.sourceOrgs = [...this.treeNode(this.fillCheck(departments))];
          this.users = [...this.treeNode(this.fillCheck(newUsers))];
        } else {
          this.$message.error(message);
        }
      } catch (err) {
        this.$message.error(err);
      }
      this.isCheckSet = true;
      this.loading = false;
    },

    // 获取条线
    async getLines(sectionCode = '') {
      this.loading = true;
      this.isLine = true;
      try {
        const params = sectionCode ? { sectionCode } : {};
        const { body, code, message } = await queryLines(params);
        if (code === '0000') {
          this.sourceOrgs = this.treeNode(
            this.fillCheck(this.switchLineOrg(body))
          );
          this.users = [];
        } else {
          this.$message.error(message);
        }
      } catch (err) {
        this.$message.error(err);
      }
      this.isCheckSet = true;
      this.loading = false;
    },

    // 条线转换
    switchLineOrg(source) {
      const departments = source.map(
        ({ lineId, name, sectionCode, sectionName, type }) => {
          return {
            departmentId: sectionCode,
            name: type === 'SECTION' ? sectionName : name,
            type,
            lineId,
            sourceCode: type === 'LINE' ? lineId : sectionCode,
            pathName: sectionName
          };
        }
      );
      return departments;
    },

    // 查询组织人员
    searchOrgPerson({ source, type }) {
      if (type === 0) {
        const newUsers = source.map(item => ({
          ..._.omit(item, ['departmentId'])
        }));
        this.users = this.treeNode(this.fillCheck(newUsers));
        this.sourceOrgs = [];
      } else {
        this.users = [];
        this.sourceOrgs = this.treeNode(this.fillCheck(source));
      }
      this.isCheckSet = false;
    },
    // 删除选中组织
    removePerson({ sourceCode, type }) {
      this.selectedList = _.cloneDeep(this.selectedList).filter(
        item => item.sourceCode !== sourceCode
      );
      this[type] = _.cloneDeep(this[type]).map(item => {
        return {
          ...item,
          isCheck: sourceCode === item.sourceCode ? false : item.isCheck
        };
      });
      this.allCheck = this.isCheckAll();
    },

    // 保存
    saveForm() {
      const isAll = ['', true, false][parseInt(this.isAll)];
      let params = {};
      if (isAll) {
        params = {
          isAll,
          lines: [],
          users: [],
          departments: []
        };
      } else {
        if (this.selectedList.length === 0) {
          this.warning = true;
          return;
        }
        params = {
          isAll,
          ...this.formatSaveOrgs()
        };
      }

      const { isAll: isCheckAll, lines, users, departments } = params;
      let configStr = '';
      const userLen = users.length,
        depLen = departments.length,
        lineLen = lines.length;

      if (!isCheckAll) {
        const userStr = this.formatUsers(userLen, users, this.allShow);
        const depStr = this.formatOrgLines(depLen, departments, '部门', this.allShow);
        const lineStr = this.formatOrgLines(lineLen, lines, '条线', this.allShow);
        const desc = this.allShow ? '<br/>'.repeat(2) : ';';
        configStr = [userStr, depStr, lineStr].filter(Boolean).join(desc);
      } else {
        configStr = '全部成员';
      }
      this.$emit('saveUserDatas', params, configStr);
    },

    formatUsers (arrLen, param, all = false) {
      let configStr = "";
      if (arrLen > 0 && arrLen < 4) {
        configStr = param
          .map((item) => item.name)
          .slice(0, 3)
          .join("、");
      } else if (arrLen >= 4) {
        if (all) {
          configStr = param.map((item) => item.name).join("、");
        } else {
          configStr =
            param
              .map((item) => item.name)
              .slice(0, 3)
              .join("、") +
            "等" +
            arrLen +
            "人";
        }
      } else {
        configStr = "";
      }
      return configStr;
    },

    formatOrgLines (arrLen, param, desc, all = false) {
      let configStr = "";
      if (arrLen === 1) {
        configStr = param.map((item) => item.name)[0];
      } else if (arrLen > 1) {
        if (all) {
          configStr = param.map((item) => item.name).join("、");
        } else {
          configStr =
            param
              .map((item) => item.name)
              .slice(0, 1)
              .join("、") +
            "等" +
            arrLen +
            "个" +
            desc;
        }
      } else {
        configStr = "";
      }
      return configStr;
    },

    formatSaveOrgs() {
      // 条线
      const lines = this.selectedList
        .filter(item => Object.keys(item).includes('type'))
        .map(({ lineId, name, sourceCode, pathName, type }) => {
          return {
            lineId: type === 'SECTION' ? '' : lineId,
            name: type === 'SECTION' ? pathName : name,
            type,
            sourceCode,
            sectionCode: sourceCode,
            sectionName: pathName
          };
        });

      // 用户
      const users = this.selectedList.filter(item =>
        Object.keys(item).includes('userId')
      );

      // 部门
      const departments = this.selectedList.filter(
        item =>
          ![...lines, ...users]
            .map(item => item.sourceCode)
            .includes(item.sourceCode)
      );

      return {
        lines,
        users,
        departments
      };
    },

    formatParams(key) {
      return this.selectedList.filter(item => Object.keys(item).includes(key));
    },

    // 全选
    selectAllPerson() {
      const checked = !this.allCheck;
      this.allCheck = checked;
      const [cloneOrgs, cloneUsers] = [
        _.cloneDeep(this.sourceOrgs),
        _.cloneDeep(this.users)
      ];

      this.sourceOrgs = this.fillCheck(cloneOrgs, checked);
      this.users = this.fillCheck(cloneUsers, checked);

      const all = [...this.sourceOrgs, ...this.users];
      const cloneSelectedList = _.cloneDeep(this.selectedList).filter(
        item => !all.map(item => item.sourceCode).includes(item.sourceCode)
      );
      this.selectedList = [
        ...cloneSelectedList,
        ...this.sourceOrgs,
        ...this.users
      ].filter(item => item.isCheck);
    },

    // 某一节点选中
    selectPerson({ type, index }) {
      const selectTree = [this.sourceOrgs, this.users][type];
      const nodes = _.cloneDeep(selectTree);
      const isCheck = nodes[index].isCheck;
      nodes[index].isCheck = !!isCheck;
      this.filterPerson(nodes, index);
      if (type === 0) {
        this.sourceOrgs = nodes;
      } else {
        this.users = nodes;
      }
      this.allCheck = this.isCheckAll();
    },

    // 判断是否全选
    isCheckAll() {
      const allNodes = [...this.sourceOrgs, ...this.users];
      return allNodes.every(item => item.isCheck);
    },

    // 过滤已选择节点
    filterPerson(nodes, index) {
      if (nodes[index].isCheck) {
        this.selectedList.push(nodes[index]);
      } else {
        this.selectedList = _.cloneDeep(this.selectedList).filter(
          item => item.sourceCode !== nodes[index].sourceCode
        );
      }
    },

    treeNode(data) {
      return _.cloneDeep(data).map(item => {
        return {
          ...item,
          isCheck: this.selectedList
            .map(nodes => nodes.sourceCode)
            .includes(item.sourceCode)
            ? true
            : item.isCheck
        };
      });
    },

    selectNextLevel(row) {
      const { departmentId: departId, sourceCode, name } = row;
      this.title = name;
      if (this.isLine) {
        this.getLines(sourceCode);
        return;
      }
      this.getDepartUser(departId);
    },

    fillCheck(departList, isCheck = false) {
      if (Array.isArray(departList) && departList.length > 0) {
        return departList.map(item => ({
          ...item,
          isCheck
        }));
      }
      return [];
    },

    handleClose() {
      this.$emit('handleClose');
    }
  }
};
</script>
<style lang="scss" scope>
.renyuanDialog {
  position: relative;
  .el-dialog__header {
    padding: 10px 20px;
    background: rgba(58, 162, 127, 0.12);
  }
  .el-dialog__body {
    padding: 0px;
  }
  .dialog-body {
    .el-tabs--border-card {
      box-shadow: none;
      border: none;
    }
    .el-tabs__content {
      padding: 0px;
    }
  }
  .dialog-title {
    display: flex;
    justify-content: space-between;
    button {
      float: right;
    }
  }
  .person {
    padding: 20px 0 0 20px;
    &.isAll {
      height: 100px;
    }
  }
  .dialog-body {
    position: relative;
    .selectedBox {
      margin: 0px 32px;
      width: 736px;
      position: absolute;
      bottom: 32px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(205, 207, 212, 1);
      z-index: 20;
      transition: height 0.5s;
      .selectedWild {
        height: 100%;
        .selectedCardBox {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-content: flex-start;
          height: 100%;
          padding: 10px 24px;
          .selectedCardWild {
            width: 50px;
            margin-right: 30px;
            margin-bottom: 15px;
            position: relative;
            .deleIcon {
              display: none;
              position: absolute;
              top: -6px;
              right: -6px;
              font-size: 12px;
              color: #0a0f13;
              text-align: center;
              border-radius: 50%;
              font-style: normal;
              cursor: pointer;
            }
          }
          .selectedCardWild:hover {
            cursor: pointer;
            .deleIcon {
              display: inline-block;
              width: 12px;
              height: 12px;
              background: #000;
              color: #fff;
              line-height: 12px;
              text-align: center;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .warn-tip {
    position: absolute;
    bottom: 40px;
    left: 20px;
    color: #ff4f4a;
  }
  .dialog-btn-group {
    position: absolute;
    bottom: 20px;
    right: 10px;
  }
}
</style>
